rebru.SweetAlert = function()
{

    var uiconfirmation = function(field) {
        var source = $(''+field);
        source.on('click', function() {
            swal.fire({
                title: source.attr('data-swal-title'),
                text: source.attr('data-swal-text'),
                type: source.attr('data-swal-type'),
                showCancelButton: true,
                confirmButtonText: source.attr('data-swal-confirmButtonText'),
                cancelButtonText: source.attr('data-swal-cancelButtonText')
            }).then(function(result) {
                if (result.value) {
                    window[source.attr('data-swal-confirmFunction')]();
                }
            });
        });
    };

    var deletion = function(deletionURL, successFunction, failFunction) {
        swal.fire({
            title: Translator.trans('warning.name'),
            text: Translator.trans('text.really_delete'),
            icon: 'warning',
            showCancelButton: true,
            customClass: {
                confirmButton: 'bg-red-thunderbird',
                cancelButton: 'bg-grey-silver'
            },
            confirmButtonText: Translator.trans('yes.name'),
            cancelButtonText: Translator.trans('no.name')
        }).then(function(result) {
            if (result.value) {
                $.ajax({
                    url: deletionURL,
                    dataType:'json',
                    success: function(data) {
                        if(data.status) {
                            swal.fire({
                                title: Translator.trans('successfull.name'),
                                text: data.message,
                                icon: 'success',
                                timer: 5000,
                                onOpen: function() {
                                    //swal.showLoading()
                                }
                            }).then(function(result) {
                                successFunction && successFunction();
                            });
                        } else {
                            swal.fire({
                                title: Translator.trans('error.name'),
                                text: data.message,
                                icon: 'error'
                            }).then(function(result) {
                                failFunction && failFunction();
                            });
                        }
                    }
                });
            }
        });
    };

    var recycle = function(recycleUrl,successFunction, failFunction) {
        swal.fire({
            title: Translator.trans('warning.name'),
            text: Translator.trans('text.really_restore'),
            icon: 'warning',
            showCancelButton: true,
            customClass: {
                confirmButton: 'bg-red-thunderbird',
                cancelButton: 'bg-grey-silver'
            },
            confirmButtonText: Translator.trans('yes.name'),
            cancelButtonText: Translator.trans('no.name')
        }).then(function(result) {
            if (result.value) {
                $.ajax({
                    url: recycleUrl,
                    dataType:'json',
                    success: function(data) {
                        if(data.status) {
                            swal.fire({
                                title: Translator.trans('successfull.name'),
                                text: data.message,
                                icon: 'success',
                                timer: 5000,
                                onOpen: function() {
                                    //swal.showLoading()
                                }
                            }).then(function(result) {
                                successFunction && successFunction();
                            });
                        } else {
                            swal.fire({
                                title: Translator.trans('error.name'),
                                text: data.message,
                                icon: 'error'
                            }).then(function(result) {
                                failFunction && failFunction();
                            });
                        }
                    }
                });
            }
        });
    };

    return {
        //main function to initiate the module
        init: function (type, sourcefield) {
            switch(type)
            {
                case 'uiconfirmations':
                    uiconfirmation(sourcefield);
                    break;
            }
        },
        deletion: function(deletionURL, successFunction, failFunction) {
            deletion(deletionURL, successFunction, failFunction);
        },

        recycle: function(recycleURL,successFunction, failFunction) {
            recycle(recycleURL,successFunction, failFunction);
        },


    };
}();